import { Component } from 'react';
import DataTable from 'Container/DataTable/DataTableContainer';
import Pagination from 'Components/Pagination/index';
import formUrlParams from 'Helpers/urlform';
import { CSVLink } from 'react-csv';
import { ReactComponent as Audio } from 'assets/images/svg/audiocall.svg';
import { ReactComponent as Video } from 'assets/images/svg/videocall.svg';
import { ReactComponent as Incoming } from 'assets/images/svg/incoming.svg';
import { ReactComponent as Outgoing } from 'assets/images/svg/Vector (2).svg';
import { ReactComponent as Missed } from 'assets/images/svg/missed.svg';
import {  formatDateTime, millisToMinutesAndSeconds } from 'Components/Common/TimeStamp';
import { tableConstants } from 'Constants';

export default class CallManagement extends Component {
  constructor(props) {
    super(props);
    const model = {
      headers : [
        {
          className: tableConstants.CALL_NAME_WIDTH,
          title: 'Call From',
          accessor: 'callFrom' /* API response */,
          chooseOption: {
            name: 'callFromSearch', /* API param name */
            Component: 'Search',
            dispatchFunction: this.handleSearch
          },
          combineapidata: [ 'callFrom', 'fromUserImage' ],
          cell: {
            type: 'image-with-name'
          },
          sortOption: true,
        },
        {
          className:tableConstants.CALL_NAME_WIDTH,
          title: 'Call To',
          accessor: 'callTo' /* API response */,
          chooseOption: {
            name: 'callToSearch', /* API param name */
            Component: 'Search',
            dispatchFunction: this.handleSearch
          },
          combineapidata: [ 'callTo', 'toUserImage' ],
          cell: {
            type: 'image-with-name'
          },
          sortOption: true,
        },
        {
          className:tableConstants.DEFAULT_WIDTH,
          title: 'Duration',
          accessor: 'duration',
          chooseOption: {
            name: 'durationTitle',
            Component: 'DurationTitle',
          },
          cell: function(rowDetails) {
            const { content, index,incomingCallDuration, outgoingCallDuration , status } = rowDetails;
            const callFrom = (outgoingCallDuration && outgoingCallDuration !== 0) ? millisToMinutesAndSeconds(outgoingCallDuration) : 0;
            const callTo = (incomingCallDuration && incomingCallDuration !== 0) ? millisToMinutesAndSeconds(incomingCallDuration) : 0;
            return <td key={ index } className={ tableConstants.DEFAULT_WIDTH }>{  status !== 0 ? `${ callFrom }/${ callTo }` : '-' }</td>;
          },
        },
        {
          className:tableConstants.CALL_NAME_WIDTH,
          title: 'Date & Time',
          accessor: 'callDateAndTime',
          chooseOption: {
            name: 'callDateAndTimeSearch',
            Component: 'DateTimeRangeComponent',
            dispatchFunction: this.handleDateSearch
          },
          cell: function(rowDetails) {
            const { index, content } = rowDetails;
            return (
              <td key={ index } id='call-date-time' className={ tableConstants.CALL_NAME_WIDTH }>
               { content && formatDateTime(content) }
              </td>
            );
          },
          sortOption: { status: true, column: 'createdAt' },
        },
        {
          className:tableConstants.DEFAULT_WIDTH,
          title: 'Call Type',
          accessor:'callType',
          combineapidata: [ 'callType', 'Audio' ],
          chooseOption: {
            name: 'callTypeSearch', /* API param name */
            Component: 'DropDown',
            DropdownText: 'All',
            dispatchFunction: this.handleSearch,
            optionRender: this.createCallType
          },
          cell: function(rowDetails) {
            const { content, index } = rowDetails;
            const td = <div className='user'>
              <i className='icon'>
                { content === 'audio' ? <Audio /> : 
                  content === 'video' ? <Video /> : 
                  ''
                }
              </i>
              { content } 
            </div>
            return <td key={ `${ content }${ index }` } className={ tableConstants.DEFAULT_WIDTH }>{ td }</td>;
          },
          /* cell: {
            type: 'icon-with-text'
          }, */
          sortOption: true,
        },
        {
          title: 'Status',
          accessor: 'status',
          chooseOption: {
            name: 'statusSearch',
            Component: 'DropDown',
            DropdownText: 'All',
            dispatchFunction: this.handleSearch,
            optionRender: this.createStatus
          },
          cell: function(rowDetails) {
            const { content, index } = rowDetails;
            const td = <div className='user'>
              <i className='icon'>
                { content === 0 ? <Missed />: 
                  content === 2 ?  <Outgoing />: 
                  ''
                }
              </i>
              { content === 0 ? 'Missed' : 'Connected' } 
            </div>
            return <td key={ index }><span className='nowrap'>{ td }</span></td>;
          },
        },
      ],
      activeEditData: '',
      filtered: [],
      responseArray: [],
      pageLimit: 10,
      initialPage: 1,
      activeSort: {},
    }
    this.state = model;
  }

  componentDidMount(){
    this.props.fetchCallManagement();
    this.props.exportCallManagement();
  }

  formUrlParams = (name, value, rest) => {
    const { filtered, activeSort } = this.state;
    const filterResponse = formUrlParams(filtered, name, value);
    this.setState({ filtered: filterResponse, ...rest }, () => {
      let updatedFilter = this.state.filtered;
      if(activeSort && activeSort.id){
        updatedFilter = [
          ...this.state.filtered,
          activeSort
        ]
      }
      this.props.fetchCallManagement(updatedFilter);
      this.props.exportCallManagement(updatedFilter);
    });
  }
  /**
   * @method sortTable
   * @summary sort for view data
   * @param {name} sortAttribite - Query string name
   * @return { function } formUrlSort
   */
  sortTable = (sortAttribite) => {
    const { activeSort } = this.state
    const sortType = (activeSort.id === sortAttribite) ? 
    ((activeSort.value && activeSort.value == 'desc') ? 'asc' : 'desc') : 'asc';
    this.setState({
      activeSort: { id: sortAttribite, value: sortType },
    }, () => {
      this.formUrlSort();
    })
  }

  /**
   * @method formUrlSort
   * @summary Construct the query string based on user selection
   * @return {function} call fetch admin user api after change local state
   */
  formUrlSort = () => {
    const updatedFilter = [
      ...this.state.filtered,
      this.state.activeSort
    ]
    this.props.fetchCallManagement(updatedFilter);
    this.props.exportCallManagement(updatedFilter);
  }

 createStatus = () => {
    const statusArray = [
      { label: 'Missed', value: 0 },
      { label: 'Connected', value: 2 }
    ];
    return statusArray.map(({ label, value }) => (
      <option key={ value } value={ value }>{ label }</option>
    ));
  }

  createCallType = () => {
    const statusArray = [ 'Audio', 'Video' ];
    return statusArray.map((type, index) => {
      return (
          <option key={ `${ type }-${ index }` } value={ type.toLowerCase() }>{type}</option>
      )
    })
  }

  handleSearch = (event) => {
    const { name, value } = event.target;
    this.formUrlParams(name, value)
  }

  handleDateSearch = (data) => {
    for (const [ key, value ] of Object.entries(data)) {
      this.formUrlParams(key, value);
    }
  };

  setPageLimit = ( name, value ) => {
    this.formUrlParams(name, value,{ pageLimit: value })
  }

  updateActiveQuery = (updatedpagination) => {
    this.setState({
      filtered: [ ...this.state.filtered, ...updatedpagination ],
    });
  };

  render() {
    const { callList, totalRecords, currentPage, loading, exportCallManagementData } = this.props;
    return (
      <>
          <div className='grid pageContainer_inner'>
            <div className='heading-block gap-10'>
              <div className='block_flex'>
                <h4>Call Management</h4>
              </div>
              <div className='block_flex'>
                { exportCallManagementData && exportCallManagementData.length !== 0 && <CSVLink
                    data = { exportCallManagementData }
                    filename = { 'Call Management Details.csv' }
                    className = 'btn btn_green'
                    onClick={ () => {
                      console.log('Export Data');
                    } }
                  >
                    Export To CSV
                  </CSVLink>
                }
              </div>
            </div>
            <div className='responsive-table ctTableBox'>
              <DataTable 
                className="data-table"
                keyField="id"
                width="100%"
                headers={ this.state.headers }
                data={ callList }
                noData="No records!" 
                loading={ loading }
                sortTable={ this.sortTable }
                activeSort={ this.state.activeSort }
                //profile={ this.props.profile }
              />
              <Pagination
                handleClick={ this.formUrlParams }
                totalRecords={ totalRecords }
                initialPage={ currentPage }
                setPageLimit={ this.setPageLimit }
                pageLimit={ this.state.pageLimit }
                updateActiveQuery={ this.updateActiveQuery }
              />
            </div>            
          </div>
      </>
    );
  }
}
